// extracted by mini-css-extract-plugin
export var tagLink = "tag-link-module--tagLink--47afc";